import { graficoValorQuantidadeStyles } from './GraficoValorQuantidade.style'

export function graficoValorQuantidadeIO() {
  return {
    styles: graficoValorQuantidadeStyles
  }
}

export type GraficoValorQuantidadeIO = ReturnType<typeof graficoValorQuantidadeIO>
